export const cartInitialState = {
  order: {
    subscription: "montly",
    shipping: {},
    menu: [],
  },
  menuObj: {
    category: "",
    day: "",
    qty: 0,
  },
  selectedOrder: {
    dailyTitle: "",
    monday: "",
    tuesday: "",
    wednesday: "",
    thursday: "",
    friday: "",
  },
};

export const cartReducer = (state, action) => {
  switch (action.type) {
    case "SELECT_SUBSCRIPTION":
      state.order.subscription = action.pkgName;
      state.order.shipping = {};
      state.order.menu = [];
      state.menuObj.category = "";
      state.menuObj.day = "";
      state.menuObj.qty = "";
      state.selectedOrder.dailyTitle = "";
      state.selectedOrder.monday = "";
      state.selectedOrder.tuesday = "";
      state.selectedOrder.wednesday = "";
      state.selectedOrder.thursday = "";
      state.selectedOrder.friday = "";

      return {
        ...state,
      };

    case "DAYS":
      state.menuObj.day = action.dayItem;
      return {
        ...state,
      };

    case "SELECT_FOOD_ITEM":
      if (state.order.subscription !== "daily") {
        state.menuObj = {
          ...state.menuObj,
          category: action.id,
          day: action.dayItem,
          qty: 1,
        };
        state.order.menu = [...state.order.menu, state.menuObj];
        if (state.menuObj.day === "Monday") {
          state.selectedOrder.monday = {
            ...state.menuObj,
            title: action.title,
            qty: state.menuObj.qty,
          };
        } else if (state.menuObj.day === "Tuesday") {
          state.selectedOrder.tuesday = {
            ...state.menuObj,
            title: action.title,
            qty: state.menuObj.qty,
          };
        } else if (state.menuObj.day === "Wednesday") {
          state.selectedOrder.wednesday = {
            ...state.menuObj,
            title: action.title,
            qty: state.menuObj.qty,
          };
        } else if (state.menuObj.day === "Thursday") {
          state.selectedOrder.thursday = {
            ...state.menuObj,
            title: action.title,
            qty: state.menuObj.qty,
          };
        } else if (state.menuObj.day === "Friday") {
          state.selectedOrder.friday = {
            ...state.menuObj,
            title: action.title,
            qty: state.menuObj.qty,
          };
        } else {
          return {
            ...state.selectedOrder,
          };
        }
        return {
          ...state,
        };
      } else {
        state.menuObj = {
          ...state.menuObj,
          category: action.id,
          day: action.tomorrow,
          qty: 1,
        };
        state.order.menu = [...state.order.menu, state.menuObj];
        state.selectedOrder.dailyTitle = action.title;
        return {
          ...state,
        };
      }

    case "PAY_NOW":
      state.order.shipping = action.payload;
      return {
        ...state,
      };

    case "INCREMENT_QTY":
      if (state.order.subscription !== "daily") {
        state.menuObj.qty = state.menuObj.qty + 1;
        
        if (state.menuObj.day === "Monday") {
          state.selectedOrder.monday.qty = state.selectedOrder.monday.qty + 1;
        } else if (state.menuObj.day === "Tuesday") {
          state.selectedOrder.tuesday.qty = state.selectedOrder.tuesday.qty + 1;
        } else if (state.menuObj.day === "Wednesday") {
          state.selectedOrder.wednesday.qty =
            state.selectedOrder.wednesday.qty + 1;
        } else if (state.menuObj.day === "Thursday") {
          state.selectedOrder.thursday.qty =
            state.selectedOrder.thursday.qty + 1;
        } else if (state.menuObj.day === "Friday") {
          state.selectedOrder.friday.qty = state.selectedOrder.friday.qty + 1;
        } else {
          return {
            ...state.selectedOrder,
          };
        }
        return {
          ...state,
        };
      } else {
        state.menuObj.qty = state.menuObj.qty + 1;
        return {
          ...state,
        };
      }

    case "DECREMENT_QTY":
      if (state.order.subscription !== "daily") {
        if (state.menuObj.qty > 0) {
          state.menuObj.qty = state.menuObj.qty - 1;
          if (state.menuObj.day === "Monday") {
            state.selectedOrder.monday.qty = state.selectedOrder.monday.qty - 1;
          } else if (state.menuObj.day === "Tuesday") {
            state.selectedOrder.tuesday.qty =
              state.selectedOrder.tuesday.qty - 1;
          } else if (state.menuObj.day === "Wednesday") {
            state.selectedOrder.wednesday.qty =
              state.selectedOrder.wednesday.qty - 1;
          } else if (state.menuObj.day === "Thursday") {
            state.selectedOrder.thursday.qty =
              state.selectedOrder.thursday.qty - 1;
          } else if (state.menuObj.day === "Friday") {
            state.selectedOrder.friday.qty = state.selectedOrder.friday.qty - 1;
          } else {
            return {
              ...state.selectedOrder,
            };
          }
          return {
            ...state,
          };
        } else {
          return {
            ...state,
          };
        }
      } else {
        if (state.menuObj.qty > 0) {
          state.menuObj.qty = state.menuObj.qty - 1;
          return {
            ...state,
          };
        } else {
          return {
            ...state,
          };
        }
      }
    default:
      break;
  }
};
